import React from "react";
import MobileHomeBanner from "../../assets/images/mobile_home_banner.jpg";
import HomeBanner from "../../assets/images/homebanner.png";
import AboutUs from "../../assets/images/aboutus.jpg";

/**
 * @author
 * @function HomePage
 **/

export const HomePage = (props) => {
    const handleClick =(val)=>{
        window.location.href  = `/${val}`;
    }
  return (
    <div>
      <div>
        <img src={HomeBanner} alt="HomeBanner" className="home-banner-img d-none d-md-block" />
        <img src={MobileHomeBanner} alt="HomeBanner" className="home-banner-img d-block d-md-none" />
      </div>

      {/* About us section */}
      <div className="container my-4">
        <div className="standards row align-items-center">
          <div
            className="col-xl-6 col-lg-6 col-md-12 order-t-1 p-md-5 p-sm-2"
            data-aos="fade-right"
          >
            <img className="img-fluid  img-rounded" src={AboutUs} alt="AboutUs" />
          </div>
          
          <div
            className="col-xl-6 col-lg-6 col-md-12 order-t-2"
            data-aos="fade-left"
          >
            <div className="heading">
              <p className="text-uppercase fw-bold  mt-3">About Us</p>

              <h1 className="mb-4 fw-bold font-red">The “RRD RAJPARIS” Story </h1>
            </div>

            <div className="content">
              <p className="fw-semibold rrd-para-justify">
              At Rajparis Redevelopment and  Constructions, we believe a home is more than just four walls – it’s where families grow, memories are made, and dreams take shape. With years of experience in real estate and construction, we are committed to building homes that reflect quality, trust, and comfort.
              </p>

              <p className="fw-semibold rrd-para-justify">
              Our projects are carefully planned to give you the best of both worlds – prime city locations and thoughtfully designed living spaces. From compact apartments to spacious family homes, we focus on creating residences that suit every lifestyle and budget.
              </p>
            </div>

            <div className="my-1">
              <div className="rrd-link red-text" onClick={() => handleClick("aboutus")}>
                <u>Learn More</u>
              </div>
            </div>
          </div>         
          
        </div>
      </div>
      {/* Joint Venture section */}
      <div className="joint-venture  mt-4">
        <div className="container p-4">
            <div className="standards row align-items-center">         
            
            <div
                className="col-xl-6 col-lg-6 col-md-12 order-2 order-md-1"
                data-aos="fade-left"
            >
                <div className="heading">
                <p className="text-uppercase fw-bold mt-3">Our Joint Venture</p>

                <h1 className="mb-4 fw-bold red-text">Joint Venture Opportunities</h1>
                </div>

                <div className="content">
                <p className="fw-semibold  rrd-para-justify">
                At Rajparis Redevelopment and  Constructions, We welcome strategic joint venture partnerships with landowners,
            investors, and property developers. Together, we aim to create
            sustainable, profitable, and long-term value-driven projects.
                </p>

                <p className="fw-semibold rrd-para-justify">
                With our expertise in planning, design, approvals, and construction, we help landowners unlock the true potential of their property while sharing in the rewards of development.
                </p>
                </div>

                <div className="my-1">
                <div className="rrd-link red-text" onClick={() => handleClick("joint-venture")}>
                    <u>Learn More</u>
                </div>
                </div>
            </div>         
            
            <div
                className="col-xl-6 col-lg-6 col-md-12 order-1 order-md-2 p-md-5 p-sm-2"
                data-aos="fade-right"
            >
                <img className="img-fluid img-rounded" src={AboutUs} alt="AboutUs" />
            </div>
            </div>
        </div>
      </div>
    </div>
  );
};
